@if (currentNode) {
	<div class="pseudo-page">
		@if(currentNode.nodeType === 'File' || currentNode.nodeType === 'WebLink') {
			<file [node]="currentNode" [isoCode]="isoCode"></file>
		}
		@if (currentNode.nodeType==='Directory') {
			<page-menu></page-menu>
		}
	</div>
}

